export const marketingConsentPartnersFI = [
  'Pop Vakuutus',
  'LendMe',
  'uScore',
  'Reefin',
  'AIG Europe S.A',
  'Willis Towers Watson Oy Ab',
];
